import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import "../style/assistantAuth.css";

const LoginAssistant = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const Login = async (e) => {
    e.preventDefault();
    if (email === "" || password === "") {
      setMessage("Please Input Email and Password");
      return;
    }
    setIsLoading(true);
    try {
      await axios.post("/assistant/login", { email, password });
      navigate("/assistant/sessions");
    } catch (error) {
      setMessage(error.response?.data?.msg || "Login failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="assistant-auth-page">
      <div className="assistant-auth-card">
        <img className="assistant-auth-logo" src={Logo} alt="logo.png" />
        <p className="assistant-auth-title">Class Assistant</p>
        <p className="assistant-auth-subtitle">Login to manage class sessions and attendance</p>

        {message && <p className="assistant-auth-message is-error">{message}</p>}

        <form onSubmit={Login}>
          <div className="mb-3">
            <label className="form-label">Email address</label>
            <input
              type="email"
              className="form-control"
              placeholder="example@gmail.com"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button type="submit" className="btn assistant-auth-btn" disabled={isLoading}>
            {isLoading ? "Loading..." : "Login"}
          </button>
        </form>

        <button type="button" className="assistant-auth-link" onClick={() => navigate("/assistant/forgot-password")}>
          Forgot password / first time login?
        </button>
      </div>
    </div>
  );
};

export default LoginAssistant;
